import React from "react";

/**
 * Structured data for search engines. Rendered into the DOM so react-snap
 * bakes it into each pre-rendered page.
 */
const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    // JSON is safe to inline once "<" is escaped (no closing the script tag)
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }}
  />
);

export const breadcrumbList = (crumbs, origin = "https://striply.xyz") => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: `${origin}${crumb.path}`,
  })),
});

export default JsonLd;
